import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import Success from './../../Images/success.png';

export default () => {
    const [value, setValue] = useState()
    //   const [firstName, setFirstName] = useState('')
    //   const [lastName, setLastName] = useState('')
    //   const [email, setEmail] = useState('')

    return (
        <div className=' payment-inner-box'>
            <div className="success-img text-center mb-5">
                <img src={Success} width={100} alt="" />
            </div>
            <div className="success-txt text-center mb-4">
                <h4>Thanks a lot for using vista</h4>
                <p>Your Mailto order <Link to="">ASK123456</Link> has successfully been placed. You’ll fin all the details about your order below, and we’ll send you a shipping confrimation email as soon as your order ships. In the meantime, you can share Mailto and earn store credit.</p>
                <p> Questions? Suggestions? insightful showe thoughts?<br/><Link to=""> Shoot us an email</Link>.</p>
            </div>
            <div className='row'>

                <div className='col-lg-12 mb-3'>
                    <div className='six columns mb-5'>

                        <select className="form-select" aria-label="Default select example">
                            <option selected>Order Review</option>
                            <option value="India">India</option>
                            <option value="Australia">Australia</option>
                            <option value="Usa">USA</option>
                        </select>
                    </div>
                    <div className="text-center">
                        <Link className='common-btn w-100' to="">Back to Property</Link>

                    </div>
                </div>

            </div>
        </div>
    )
}